import { render } from "./Bot.vue?vue&type=template&id=5bdd4cd9"
import script from "./Bot.vue?vue&type=script&lang=js"
export * from "./Bot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__